import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import SinglePlayer from './game/singleplayer/SinglePlayer';
// import Lobby from './screens/multiplayer/lobby/Lobby';
// import NewGame from './screens/multiplayer/NewGame';
// import JoinGame from './screens/multiplayer/join/JoinGame';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<App />}/>
        <Route path="/ai" element={<SinglePlayer />}/>
        {/* <Route path="/multi" element={<Lobby />}/>
        <Route path="/new" element={<NewGame />}/>
        <Route path="/join" element={<JoinGame />}/> */}
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
